import React from "react"
import { css } from "@emotion/core"

import {
  daysToMilliseconds,
  setWithExpiry,
  getWithExpiry,
} from "../utils/local_storage_utils"

const SCROLL_DISTANCE_FOR_POPUP = 4500
const DAYS_TO_PERSIST_POPUP_CLOSE = 30
const LOCALSTORAGE_KEY = "email_pop_closed"

class PopupSubscribeForm extends React.Component {
  constructor(props) {
    super(props)

    // intentionally verbose to preserve order of precedence.
    // (Un)intentionally using prettier will strip parens and
    // cause a one-liner to error out.
    let popup_previously_closed_and_not_expired = false
    if (getWithExpiry(LOCALSTORAGE_KEY) != null) {
      popup_previously_closed_and_not_expired = true
    }

    let initialScrollY = 0

    if (typeof window !== "undefined") {
      initialScrollY = window.scrollY

      let that = this
      window.addEventListener("scroll", function() {
        if (!that.state.popupClosed) {
          let totalScrollDistance =
            that.state.totalScrollDistance +
            Math.abs(window.scrollY - that.state.prevScrollY)

          that.setState({
            totalScrollDistance: totalScrollDistance,
            prevScrollY: window.scrollY,
            popupClosed: that.state.popupClosed,
            visibilityCss: that.state.visibilityCss,
          })

          if (that.shouldShowPopup()) {
            that.showPopup()
          }
        }
      })
    }

    this.state = {
      prevScrollY: initialScrollY,
      totalScrollDistance: 0,
      popupClosed: popup_previously_closed_and_not_expired,
      visibilityCss: "display: none; opacity: 0;",
    }

    this.closePopup = this.closePopup.bind(this)
  }

  shouldShowPopup() {
    return (
      !this.state.popupClosed &&
      this.state.totalScrollDistance > SCROLL_DISTANCE_FOR_POPUP
    )
  }

  showPopup() {
    this.setState({
      totalScrollDistance: this.state.totalScrollDistance,
      prevScrollY: this.state.prevScrollY,
      popupClosed: this.state.popupClosed,
      visibilityCss: `-webkit-animation: fadeInFromNone 0.25s ease-out;
        -moz-animation: fadeInFromNone 0.25s ease-out;
        -o-animation: fadeInFromNone 0.25s ease-out;
        animation: fadeInFromNone 0.25s ease-out;`,
    })
  }

  closePopup() {
    this.setState({
      totalScrollDistance: this.state.totalScrollDistance,
      prevScrollY: this.state.prevScrollY,
      popupClosed: true,
      visibilityCss: `display: none; opacity: 0`,
    })

    setWithExpiry(
      LOCALSTORAGE_KEY,
      true,
      daysToMilliseconds(DAYS_TO_PERSIST_POPUP_CLOSE)
    )
  }

  render() {
    return (
      <div
        css={css`
          padding: 20px 30px 30px 30px;
          text-align: left;
          background-color: #eee;
          border-radius: 3px;

          max-width: 430px;
          z-index: 1000;
          position: fixed;
          bottom: 20px;
          right: 0;

          border: 1px solid #ccc;
          box-shadow: 0px 5px 18px 0px rgba(0, 0, 0, 0.1);

          transition: opacity 0.25s ease-in;
          ${this.state.visibilityCss};

          @media only screen and (max-width: 576px) {
            max-width: 100%;
            width: 100%;
            bottom: 0;
          }
        `}
      >
        <div
          css={css`
            background-color: rgba(0, 0, 0, 0);
            height: 32px;
            width: 32px;
            border-radius: 16px;
            text-align: center;

            font-size: 32px;
            line-height: 30px;
            cursor: pointer;
            position: absolute;
            right: 15px;
            top: 15px;
            color: #888;

            -webkit-touch-callout: none; /* iOS Safari */
            -webkit-user-select: none; /* Safari */
            -khtml-user-select: none; /* Konqueror HTML */
            -moz-user-select: none; /* Old versions of Firefox */
            -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */

            transition: background-color 0.15s ease-in-out;

            :hover {
              background-color: #e0ddf6;
            }
          `}
          onClick={this.closePopup}
        >
          &times;
        </div>
        <div
          css={css`
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 8px;
            @media only screen and (max-width: 576px) {
              font-size: 17px;
            }
          `}
        >
          At least this isn't a full screen popup.
        </div>
        <div
          css={css`
            margin-bottom: 16px;
            font-size: 15px;
            line-height: 20px;
          `}
        >
          If these guides are helpful and you want more, we can send you an
          update when we complete a new guide, have a new recommendation, or
          uncover a new deal.
        </div>
        <form
          css={css`
            text-align: center;
            margin-bottom: 0;
          `}
          name="Contact Form"
          method="POST"
          data-netlify="true"
        >
          <input type="hidden" name="form-name" value="Contact Form" />
          <div
            css={css`
              margin: 0 auto;
              background: #fff;
              box-shadow: 0 2px 5px -1px rgba(0, 0, 0, 0.15);
              border-radius: 3px;
              max-width: 450px;
              font-size: 16px;
              display: flex;
              //   justify-content: space-between;
              overflow: hidden;
            `}
          >
            <input
              css={css`
                border: none;
                outline: none;
                margin: 0;
                padding: 8px 12px;
                flex-grow: 1;
                min-width: 0;
              `}
              type="email"
              name="email"
              placeholder="Email"
            />
            <button
              css={css`
                margin: 0;
                border: none;
                outline: none;
                background-color: #fff;
                padding: 8px 12px;
                color: #473dc7;
                font-weight: 500;
                border-left: 1px solid #ddd;
                transition: background-color 0.08s ease-in-out;
                flex-shrink: 0;

                :hover {
                  background-color: #e0ddf6;
                }

                :active {
                  background-color: #473dc7;
                  color: #fff;
                }
              `}
              type="submit"
            >
              Get Updates
            </button>
          </div>
          <div
            css={css`
              max-width: 400px;
              margin: 0 auto;
              margin-top: 10px;
              font-size: 12px;
              line-height: 16px;
              color: #888;
            `}
          >
            We won't share your info. This is mainly another way for us to get
            feedback on our guides. You'll be able to unsubscribe at any time.
          </div>
        </form>
      </div>
    )
  }
}

export default PopupSubscribeForm
